import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  ISectiune,
  ISectiuneAddPayload,
  ISectiuneUpdatePayload,
} from './sectiuni.interface';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SectiuniService {
  private basePath = environment.interop.basePath;
  private getSectionsUrl =
    this.basePath +
    environment.interop.platform.nomenclatoare.section.getSections;
  private getSectionsDTUrl =
    this.basePath +
    environment.interop.platform.nomenclatoare.section.getSections +
    '-dt';
  private token!: string;
  private httpOptions: any;
  private storeSectionURL =
    this.basePath +
    environment.interop.platform.nomenclatoare.section.storeSection;
  private updateSectionUrl =
    this.basePath +
    environment.interop.platform.nomenclatoare.section.putSection;
  private deleteSectionUrl =
    this.basePath +
    environment.interop.platform.nomenclatoare.section.deleteSection;
  private getSectionsActiveUrl =
    this.basePath +
    environment.interop.platform.nomenclatoare.section.getSectionsActive;
  private getSectionsPublicUrl =
    this.basePath +
    environment.interop.platform.nomenclatoare.section.getSectionsActivePublic;

  constructor(private http: HttpClient) {}

  getSections(): Observable<ISectiune[]> {
    return this.http
      .get(this.getSectionsUrl, this.httpOptions)
      .pipe(map((response: any) => response.data));
  }

  getSectionsDT() {
    return this.http.get(this.getSectionsDTUrl, this.httpOptions);
  }

  addSection(section: ISectiuneAddPayload) {
    return this.http.post(this.storeSectionURL, section, this.httpOptions);
  }

  updateSection(section: ISectiuneUpdatePayload) {
    return this.http.put(this.updateSectionUrl, section, this.httpOptions);
  }

  deleteSection(sectionId: number) {
    return this.http.delete(this.deleteSectionUrl + sectionId);
  }

  getSectionsActive() {
    return this.http.get(this.getSectionsActiveUrl, this.httpOptions);
  }

  getSectionsPublic() {
    return this.http.get(this.getSectionsPublicUrl, this.httpOptions);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
